import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-connection-success',
  templateUrl: './connection-success.component.html',
  styleUrls: ['./connection-success.component.css'],
  standalone: false,
})
export class ConnectionSuccessComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  LinktoPage(page) {
    this.router.navigate([page]);
  }
}
